// Generated by CoffeeScript 2.7.0
var Delegator;

import Base from './base.js';

export default Delegator = class Delegator extends Base {
  constructor(delegator) {
    super();
    this.delegator = delegator;
  }

};
